/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateImporterDto,
    CreateImporterDtoFromJSON,
    CreateImporterDtoToJSON,
    ImportTypeEnum,
    ImportTypeEnumFromJSON,
    ImportTypeEnumToJSON,
    ImporterDto,
    ImporterDtoFromJSON,
    ImporterDtoToJSON,
    UpdateImporterDto,
    UpdateImporterDtoFromJSON,
    UpdateImporterDtoToJSON,
} from '../models';

export interface ImporterControllerCreateRequest {
    createImporterDto: CreateImporterDto;
}

export interface ImporterControllerDeleteRequest {
    id: ImportTypeEnum;
}

export interface ImporterControllerUpdateRequest {
    id: ImportTypeEnum;
    updateImporterDto: UpdateImporterDto;
}

/**
 * 
 */
export class ImporterApi extends runtime.BaseAPI {

    /**
     * Create importer configuration
     */
    async importerControllerCreateRaw(requestParameters: ImporterControllerCreateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ImporterDto>> {
        if (requestParameters.createImporterDto === null || requestParameters.createImporterDto === undefined) {
            throw new runtime.RequiredError('createImporterDto','Required parameter requestParameters.createImporterDto was null or undefined when calling importerControllerCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/importer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateImporterDtoToJSON(requestParameters.createImporterDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImporterDtoFromJSON(jsonValue));
    }

    /**
     * Create importer configuration
     */
    async importerControllerCreate(requestParameters: ImporterControllerCreateRequest, initOverrides?: RequestInit): Promise<ImporterDto> {
        const response = await this.importerControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete importer configuration
     */
    async importerControllerDeleteRaw(requestParameters: ImporterControllerDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling importerControllerDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/importer/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Delete importer configuration
     */
    async importerControllerDelete(requestParameters: ImporterControllerDeleteRequest, initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.importerControllerDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get configuration for all importers
     */
    async importerControllerGetListRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ImporterDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/importer/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ImporterDtoFromJSON));
    }

    /**
     * Get configuration for all importers
     */
    async importerControllerGetList(initOverrides?: RequestInit): Promise<Array<ImporterDto>> {
        const response = await this.importerControllerGetListRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update importer configuration
     */
    async importerControllerUpdateRaw(requestParameters: ImporterControllerUpdateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ImporterDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling importerControllerUpdate.');
        }

        if (requestParameters.updateImporterDto === null || requestParameters.updateImporterDto === undefined) {
            throw new runtime.RequiredError('updateImporterDto','Required parameter requestParameters.updateImporterDto was null or undefined when calling importerControllerUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/importer/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateImporterDtoToJSON(requestParameters.updateImporterDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImporterDtoFromJSON(jsonValue));
    }

    /**
     * Update importer configuration
     */
    async importerControllerUpdate(requestParameters: ImporterControllerUpdateRequest, initOverrides?: RequestInit): Promise<ImporterDto> {
        const response = await this.importerControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
